module.exports = __webpack_public_path__ + "media/honey-icons/icon-holidaymode-7fca40fb.svg";